"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetLotteryRequest = void 0;
var GetLotteryRequest = /** @class */ (function () {
    function GetLotteryRequest() {
    }
    return GetLotteryRequest;
}());
exports.GetLotteryRequest = GetLotteryRequest;
;
//# sourceMappingURL=getLottery.request.js.map